export function buildAuthFailureResult(error, email = '') {
  const message = error?.response?.data?.error || 'Login failed';
  const requiresEmailVerification =
    error?.response?.status === 403 && message === 'Email verification required';

  return {
    success: false,
    error: message,
    requiresEmailVerification,
    email: requiresEmailVerification ? String(email || '').trim().toLowerCase() : '',
  };
}

// Where a person lands after signing in: the chat opens first (Rudy 2026-11-03, top-bar design).
export const DEFAULT_APP_PATH = '/ai-chat';

export function getSafePostAuthPath(locationLike = {}, fallback = DEFAULT_APP_PATH) {
  const statePath = locationLike?.state?.from;
  const queryPath = new URLSearchParams(locationLike?.search || '').get('next');
  const candidate = statePath || queryPath;

  return typeof candidate === 'string' &&
    candidate.startsWith('/') &&
    !candidate.startsWith('//')
    ? candidate
    : fallback;
}

export function buildVerifyEmailPath(email = '', nextPath = '') {
  const normalizedEmail = String(email || '').trim();
  const params = new URLSearchParams();

  if (normalizedEmail) {
    params.set('email', normalizedEmail);
  }
  if (nextPath && nextPath !== DEFAULT_APP_PATH) {
    params.set('next', nextPath);
  }

  const query = params.toString();
  return query ? `/verify-email?${query}` : '/verify-email';
}
